import { defineChain } from "viem";

export const immutableZkEvmTestnet = defineChain({
  id: 13473,
  id_str: "imtbl-zkevm-testnet",
  name: 'Immutable zkEVM Testnet',
  network: '',
  nativeCurrency: {
    decimals: 18,
    name: 'Immutable Coin',
    symbol: 'IMX',
  },
  rpcUrls: {
    default: {
      http: ['https://rpc.testnet.immutable.com'],
    },
    public: {
        http: ['https://rpc.testnet.immutable.com'],
    },
  },
  blockExplorers: {
    default: {
      name: 'Immutable Testnet Explorer',
      url: 'https://explorer.testnet.immutable.com/',
    },
  },
  contracts: {
    multicall3: {
      address: '0x2CC787Ed364600B0222361C4188308Fa8E68bA60',
      blockCreated: 5977391,
    },
  },
  testnet: true,
});

export const immutableZkEvm = /*#__PURE__*/ defineChain({
    id: 13371,
    id_str: "imtbl-zkevm-mainnet",
    name: 'Immutable zkEVM',
    network: '',
    nativeCurrency: {
      decimals: 18,
      name: 'Immutable Coin',
      symbol: 'IMX',
    },
    rpcUrls: {
      default: {
        http: ['https://rpc.immutable.com'],
      },
      public: {
        http: ['https://rpc.immutable.com'],
      }
    },
    blockExplorers: {
      default: {
        name: 'Immutable Explorer',
        url: 'https://explorer.immutable.com',
      },
    },
    contracts: {
      multicall3: {
        address: '0x236bdA4589e44e6850f5aC6a74BfCa398a86c6c0',
        blockCreated: 4335972,
      },
    },
  })
  
